<!-- Botón flotante para abrir el Asistente SIRA -->
<button
  *ngIf="!aiSvc.isOpen"
  class="sira-ai-fab mat-elevation-z6"
  (click)="togglePanel()"
  matTooltip="Asistente Inteligente SIRA"
  matTooltipPosition="left"
  aria-label="Abrir asistente de IA"
>
  <mat-icon>psychology</mat-icon>
  <span class="ai-fab-badge" *ngIf="selectedCEA"></span>
</button>

<!-- Ventana emergente del Asistente -->
<div *ngIf="aiSvc.isOpen" class="sira-ai-panel mat-elevation-z12" [ngClass]="themeClass">
  <!-- Cabecera -->
  <div class="ai-header">
    <div class="header-title">
      <mat-icon class="header-icon">psychology</mat-icon>
      <div class="title-text">
        <span class="name">Asistente SIRA</span>
        <span class="status" [ngClass]="{'generating': aiSvc.isGenerating}">
          {{ aiSvc.isGenerating ? 'Pensando...' : 'En línea' }}
        </span>
      </div>
    </div>

    <div class="header-actions">
      <span *ngIf="selectedCEA" class="cea-badge" matTooltip="CEA activo en contexto">
        {{ selectedCEA }}
      </span>
      <button mat-icon-button (click)="resetChat()" matTooltip="Reiniciar conversación" class="header-btn">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-icon-button (click)="togglePanel()" matTooltip="Cerrar" class="header-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Contenedor de Mensajes -->
  <div #scrollContainer class="ai-messages">
    <div
      *ngFor="let msg of aiSvc.messages"
      class="ai-message-row"
      [ngClass]="msg.role === 'user' ? 'row-user' : 'row-assistant'"
    >
      <div class="message-avatar" *ngIf="msg.role === 'assistant'">
        <mat-icon>smart_toy</mat-icon>
      </div>

      <div class="message-bubble" [ngClass]="{'bubble-user': msg.role === 'user', 'bubble-assistant': msg.role === 'assistant', 'bubble-error': msg.error}">
        <div class="message-content">
          <span *ngIf="!msg.content && msg.isStreaming" class="loading-continuity-text">
            <mat-icon class="inline-spin">sync</mat-icon>
            {{ aiSvc.continuityTargetLabel ? 'Cargando datos de ' + aiSvc.continuityTargetLabel + '...' : 'Consultando información...' }}
          </span>
          <span *ngIf="msg.content" [innerHTML]="formatContent(msg.content)"></span>
        </div>
        <div *ngIf="msg.actionResult" class="message-action-badge" [ngClass]="{'action-success': msg.actionResult.success, 'action-fail': !msg.actionResult.success}">
          <mat-icon class="action-icon">{{ msg.actionResult.action === 'navigate' ? 'explore' : (msg.actionResult.success ? 'filter_alt' : 'error_outline') }}</mat-icon>
          <span>{{ msg.actionResult.message }}</span>
        </div>
        <span *ngIf="msg.isStreaming && msg.content" class="streaming-dot"></span>
        <div class="message-time">{{ msg.timestamp | date:'HH:mm' }}</div>
      </div>
    </div>

    <!-- Sugerencias rápidas cuando la conversación acaba de empezar -->
    <div class="ai-suggestions" *ngIf="aiSvc.messages.length <= 2 && !aiSvc.isGenerating">
      <span class="suggestions-label">Sugerencias:</span>
      <div class="chips-container">
        <button
          *ngFor="let s of suggestions"
          class="suggestion-chip"
          (click)="useSuggestion(s)"
        >
          {{ s }}
        </button>
      </div>
    </div>
  </div>

  <!-- Pie de entrada -->
  <div class="ai-footer">
    <textarea
      #inputField
      [(ngModel)]="userInput"
      (keydown)="onKeyDown($event)"
      placeholder="Escribe tu consulta o duda sobre SIRA..."
      rows="2"
      class="ai-input"
    ></textarea>

    <div class="footer-actions">
      <button
        *ngIf="aiSvc.isGenerating"
        mat-mini-fab
        color="warn"
        (click)="aiSvc.stopGeneration()"
        matTooltip="Detener respuesta"
        class="action-btn"
      >
        <mat-icon>stop</mat-icon>
      </button>

      <button
        *ngIf="!aiSvc.isGenerating"
        mat-mini-fab
        color="primary"
        [disabled]="!userInput.trim()"
        (click)="onSend()"
        matTooltip="Enviar (Enter)"
        class="action-btn"
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
